import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  input: {
    margin: [theme.spacing(3), 0],
  },
  warning: {
    backgroundColor: theme.palette.colors.warningBackground,
  },
  warningHeader: {
    color: theme.palette.colors.red,
    letterSpacing: '0.03em',
    textTransform: 'uppercase',
  },
  warningText: {
    '& p': {
      fontFamily: 'Manrope',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '14px',
      lineHeight: '20px',
      margin: 0,
    },
    '& a': {
      fontWeight: 700,
      '&:hover': {
        color: theme.palette.colors.teal,
      },
    },
  },
  buttonBox: {
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    borderRadius: 4,
    height: 50,
    width: '100%',
    fontSize: 20,
    backgroundColor: theme.palette.colors.lightTeal,
    color: theme.palette.colors.teal,
    marginBottom: theme.spacing(2),
    '&:hover': {
      color: theme.palette.colors.white,
      backgroundColor: theme.palette.colors.teal,
    },
    [theme.breakpoints.up('mobile')]: {
      width: '40%',
      marginRight: theme.spacing(2),
    },
  },
  // button: {
  //   borderRadius: 4,
  //   fontSize: '1.3rem',
  //   margin: [10, 0],
  //   width: '100%',
  //   height: 'unset',
  //   '& svg': { height: '1.3rem', width: '1.3rem' },
  //   [theme.breakpoints.up('mobile')]: {
  //     width: 350,
  //   },
  // },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/components/DownPaymentTargetQuestion/useStyles.js